var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconCarbonOffset40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_19414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7848 18.9575H21.3994L22.2067 36.1797H18.9775L19.7848 18.9575Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5921 18.9578C22.0783 18.9578 23.2831 15.9458 23.2831 12.2304C23.2831 8.5149 22.0783 5.50293 20.5921 5.50293C19.1059 5.50293 17.9011 8.5149 17.9011 12.2304C17.9011 15.9458 19.1059 18.9578 20.5921 18.9578Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6685 20.0343C21.0404 21.3813 23.261 23.7461 26.6284 25.3163C29.9957 26.8865 33.2347 27.0675 33.8627 25.7206C34.4908 24.3736 32.2702 22.0088 28.9029 20.4386C25.5355 18.8684 22.2966 18.6874 21.6685 20.0343Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3315 20.0343C19.9596 21.3813 17.739 23.7461 14.3716 25.3163C11.0043 26.8865 7.76534 27.0675 7.13725 25.7206C6.50917 24.3736 8.72977 22.0088 12.0971 20.4386C15.4645 18.8684 18.7034 18.6874 19.3315 20.0343Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5922 23.263C22.3756 23.263 23.8214 21.8173 23.8214 20.0339C23.8214 18.2504 22.3756 16.8047 20.5922 16.8047C18.8088 16.8047 17.363 18.2504 17.363 20.0339C17.363 21.8173 18.8088 23.263 20.5922 23.263Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_19414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconCarbonOffset40);
export default __webpack_public_path__ + "static/media/pictogramBeaconCarbonOffset40.5a2fdb569da6f1fbbb8583f1d58677e2.svg";
export { ForwardRef as ReactComponent };